import { Component, Input } from '@angular/core';
import { AttributeCount } from 'src/app/shared/models/dashboard/attributeCount';

@Component({
  selector: 'attribute-chart',
  templateUrl: 'attribute-chart.component.html',
  styleUrls: ['attribute-chart.component.scss'],
})
export class AttributeChartComponent {
  @Input()
  attributeCount: AttributeCount;
  @Input()
  click: any;
  @Input()
  disableBarClick: boolean = false;
  @Input()
  showTitle: boolean = true;
  @Input()
  showSearchIcon: boolean = false;

  constructor() {}

  searchCallback(value: string) {
    this.doClick(value);
  }

  clickCallback(value: string) {
    if (this.click && !this.disableBarClick) {
      this.doClick(value);
    }
  }

  private doClick(value: string) {
    this.click(this.attributeCount.id, value);
  }
}
